import { useNavigate } from 'react-router-dom'
import { Building2, Mail, Search } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { cn } from '@/lib/utils'

export default function OrgChoiceStep() {
  const navigate = useNavigate()

  const choices = [
    {
      path: '/onboarding/create-organization',
      title: 'Create Organization',
      description: 'Create and own a new workspace',
      icon: Building2
    },
    {
      path: '/onboarding/invite-token',
      title: 'Join via Invite',
      description: 'Use an invite token from your team',
      icon: Mail
    },
    {
      path: '/onboarding/browse-organizations',
      title: 'Browse & Request',
      description: 'Find public organizations and request access',
      icon: Search
    }
  ]

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold text-foreground">Step 2: Choose organization flow</h2>
        <p className="text-muted-foreground mt-1">Select how you want to join or create an organization</p>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        {choices.map((choice) => (
          <Card 
            key={choice.path}
            className={cn(
              'cursor-pointer transition-all hover:border-primary hover:shadow-md',
              'hover:bg-muted/50'
            )}
            onClick={() => navigate(choice.path)}
          >
            <CardHeader className="pb-2">
              <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center mb-2">
                <choice.icon className="h-5 w-5 text-primary" />
              </div>
              <CardTitle className="text-base">{choice.title}</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription>{choice.description}</CardDescription>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  )
}
